import type { ReactElement } from 'react';
import { Suspense } from 'react';
import { Backdrop } from '@mui/material';

import { PageLoaderSpinner } from '/shared/Spinner';

import type { FCWithChildren } from './models';

export const DefaultFallback = (
  <Backdrop open={true} data-testid='page-loader'>
    <PageLoaderSpinner />
  </Backdrop>
);
export interface ILoadableProps {
  fallback?: ReactElement;
}
export const Loadable: FCWithChildren<ILoadableProps> = ({ fallback = DefaultFallback, children }) => {
  return <Suspense fallback={fallback}>{children}</Suspense>;
};
